export default __webpack_public_path__ + "static/media/profile-status-icon.5c30ca18.svg";